export default __webpack_public_path__ + "static/media/minimize.ecf25299.svg";